import { cn } from "@/lib/utils"

import newActive from "@/assets/img/today/moon/phase-icons/new-active.svg"
import newInactive from "@/assets/img/today/moon/phase-icons/new-inactive.svg"
import waxCActive from "@/assets/img/today/moon/phase-icons/waxing-crescent-active.svg"
import waxCInactive from "@/assets/img/today/moon/phase-icons/waxing-crescent-inactive.svg"
import q1Active from "@/assets/img/today/moon/phase-icons/first-quarter-active.svg"
import q1Inactive from "@/assets/img/today/moon/phase-icons/first-quarter-inactive.svg"
import waxGActive from "@/assets/img/today/moon/phase-icons/waxing-gibbous-active.svg"
import waxGInactive from "@/assets/img/today/moon/phase-icons/waxing-gibbous-inactive.svg"
import fullActive from "@/assets/img/today/moon/phase-icons/full-active.svg"
import fullInactive from "@/assets/img/today/moon/phase-icons/full-inactive.svg"
import wanGActive from "@/assets/img/today/moon/phase-icons/waning-gibbous-active.svg"
import wanGInactive from "@/assets/img/today/moon/phase-icons/waning-gibbous-inactive.svg"
import q3Active from "@/assets/img/today/moon/phase-icons/last-quarter-active.svg"
import q3Inactive from "@/assets/img/today/moon/phase-icons/last-quarter-inactive.svg"
import wanCActive from "@/assets/img/today/moon/phase-icons/waning-crescent-active.svg"
import wanCInactive from "@/assets/img/today/moon/phase-icons/waning-crescent-inactive.svg"

/** Eight lunar phases in cycle order (new → waning crescent). */
export type MoonPhaseKey = "new" | "waxC" | "q1" | "waxG" | "full" | "wanG" | "q3" | "wanC"

/** Design-exported SVG per phase, in its active (selected) and inactive states. */
const ICONS: Record<MoonPhaseKey, { active: string; inactive: string }> = {
  new: { active: newActive, inactive: newInactive },
  waxC: { active: waxCActive, inactive: waxCInactive },
  q1: { active: q1Active, inactive: q1Inactive },
  waxG: { active: waxGActive, inactive: waxGInactive },
  full: { active: fullActive, inactive: fullInactive },
  wanG: { active: wanGActive, inactive: wanGInactive },
  q3: { active: q3Active, inactive: q3Inactive },
  wanC: { active: wanCActive, inactive: wanCInactive },
}

interface MoonPhaseIconProps {
  phase: MoonPhaseKey
  /** Use the bright active icon once the Moon has reached the phase. */
  active: boolean
  className?: string
  label?: string
}

/** A single lunar-phase icon, using the design's exported SVGs directly. */
export function MoonPhaseIcon({ phase, active, className, label }: MoonPhaseIconProps) {
  return (
    <img
      src={active ? ICONS[phase].active : ICONS[phase].inactive}
      alt={label ?? ""}
      className={cn("size-9 shrink-0", className)}
    />
  )
}
